// extracted by mini-css-extract-plugin
module.exports = {"TabWrapper":"notifications_TabWrapper__n7UO_","Settings":"notifications_Settings__didXI"};